import { LinearProgress } from '@material-ui/core';
import { memo } from 'react';

export default memo(function Loading() {
  return <LinearProgress data-testid="loading-indicator" />;
});
